export default "__VITE_ASSET__13e87203__"